import { cn } from "@utils";

export const TabGroup = ({ children, className }) => {
  return (
    <div className={cn("", className)}>
      <div aria-label="Tabs" className="-mb-px flex">
        {children}
      </div>
    </div>
  );
};

export const Tab = ({ active, onClick, children }) => {
  return (
    <div
      onClick={onClick}
      role="button"
      className={cn(
        "flex items-center flex-1 justify-center border-2 text-center text-sm font-medium select-none cursor-pointer py-2 px-4",
        "border-l-0 border-r-0",
        "first:border-l-2 last:border-r-2",
        "first:rounded-tl-xl first:rounded-bl-xl last:rounded-tr-xl last:rounded-br-xl",
        active
          ? "border-2 border-primary text-primary bg-primary/[0.03]"
          : "border-zinc-300 text-zinc-500 hover:text-zinc-700 hover:bg-zinc-100"
      )}
    >
      {children}
    </div>
  );
};
